import { MonoTypeOperatorFunction, Observable, throwError, timer } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

const DEFAULT_RETRY_COUNT = 3;
const DEFAULT_RETRY_DELAY = 1000;

export function retryIf<T>(retryFn?: (error: unknown) => boolean): MonoTypeOperatorFunction<T> {
  return (input$): Observable<T> => {
    if (retryFn) {
      return input$.pipe(
        retry({
          count: DEFAULT_RETRY_COUNT,
          delay: (error, retryCount) => {
            if (retryCount < DEFAULT_RETRY_COUNT && retryFn(error)) {
              return timer(DEFAULT_RETRY_DELAY);
            } else {
              return throwError(() => error);
            }
          },
          resetOnSuccess: true, // Reset retry count on successful requests
        }),
        catchError((error: unknown) => {
          return throwError(() => error);
        }),
      );
    }
    return input$;
  };
}
